import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Task } from './task.model';
import { environment } from '../../../environments/environment';
import { Page } from '../../models/page-wrapper.model';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  private apiUrl = `${environment.restApiUrl}tasks`;

  constructor(private http: HttpClient) { }

  /**
   * Retrieves a paginated list of tasks.
   * @param params HttpParams for pagination, sorting, and filtering.
   */
  getAllTasks(params: HttpParams): Observable<Page<Task>> {
    return this.http.get<Page<Task>>(this.apiUrl, { params });
  }

  /**
   * Gets a single task by its ID.
   * @param id The ID of the task.
   */
  getTaskById(id: number): Observable<Task> {
    return this.http.get<Task>(`${this.apiUrl}/${id}`);
  }

  /**
   * Creates a new task.
   * @param task The task data to create.
   */
  createTask(task: Partial<Task>): Observable<Task> {
    return this.http.post<Task>(this.apiUrl, task);
  }

  /**
   * Updates an existing task.
   * @param id The ID of the task to update.
   * @param task The updated task data.
   */
  updateTask(id: number, task: Partial<Task>): Observable<Task> {
    return this.http.put<Task>(`${this.apiUrl}/${id}`, task);
  }

  /**
   * Deletes a task by its ID.
   * @param id The ID of the task to delete.
   */
  deleteTask(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}